export const coursePath = 'education/ce/courses/';
export const endowmentPath = 'education/ce/endowments/';
export const defaultEventTitles = ["Annual Meeting 2023", "Annual Meeting 2024", "Annual Meeting 2025"];